import React from 'react';

export const Sort: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg viewBox='0 0 256 256' width={width || '1em'} height={height || '1em'}>
        <path fill='none' d='M0 0h256v256H0z' />
        <path fill='none' stroke={color || 'currentColor'} strokeLinecap='round' strokeLinejoin='round' strokeWidth='16' d='m112 176-32 32-32-32M80 48v160M144 80l32-32 32 32M176 208V48' />
    </svg>
);
